var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoDashboards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 374,
    height: 258,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M309.072 220.561c1.513-12.088 9.052-23.998 20.653-27.931a55.8 55.8 0 0 0 .002 38.53c1.783 4.792 4.268 9.937 2.591 14.766-1.043 3.005-3.595 5.304-6.448 6.741-2.853 1.438-6.02 2.123-9.146 2.794l-.616.506c-4.963-11.137-8.549-23.319-7.036-35.406"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M329.84 192.858a47.83 47.83 0 0 0-12.001 26.996 20.5 20.5 0 0 0 .237 6.468 11.8 11.8 0 0 0 2.965 5.495c1.337 1.46 2.874 2.798 3.83 4.555a7.217 7.217 0 0 1 .357 5.922c-.844 2.406-2.509 4.368-4.203 6.23-1.881 2.067-3.868 4.185-4.668 6.925-.097.332-.61.164-.513-.168 1.391-4.768 6.049-7.477 8.271-11.772 1.036-2.004 1.471-4.33.5-6.445-.85-1.85-2.434-3.232-3.8-4.698a12.6 12.6 0 0 1-3.101-5.266 19 19 0 0 1-.486-6.435 46.3 46.3 0 0 1 3.42-14.142 48.8 48.8 0 0 1 8.834-14.068c.231-.257.587.148.358.403"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M317.985 216.606a7.24 7.24 0 0 1-4.15-2.763 7.17 7.17 0 0 1-1.363-4.776c.027-.345.567-.318.54.026a6.63 6.63 0 0 0 1.268 4.446 6.7 6.7 0 0 0 3.874 2.557c.338.08.167.589-.169.51M320.265 231.167a13.88 13.88 0 0 0 6.234-7.989c.098-.332.611-.163.513.168a14.44 14.44 0 0 1-6.504 8.3c-.299.177-.541-.303-.243-.479M323.265 201.876c.614.29 1.29.424 1.968.389a4.1 4.1 0 0 0 1.917-.585c.298-.18.539.301.243.48a4.61 4.61 0 0 1-4.297.226.276.276 0 0 1-.172-.339.273.273 0 0 1 .341-.171"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M365.086 214.22q-.274.175-.547.358a54 54 0 0 0-6.903 5.355q-.255.226-.502.458a56.6 56.6 0 0 0-12.361 16.814 55 55 0 0 0-3.028 7.784c-1.117 3.683-2.033 7.766-4.245 10.779a10 10 0 0 1-.738.906h-19.985c-.046-.023-.091-.041-.137-.064l-.798.037c.032-.141.069-.286.101-.426.018-.082.041-.163.059-.245q.021-.083.036-.158l.014-.05c.009-.05.023-.095.032-.141q.301-1.217.62-2.433c0-.004 0-.004.005-.009 1.637-6.175 3.807-12.269 6.839-17.842.091-.168.182-.34.283-.508a52.4 52.4 0 0 1 4.737-7.14 47 47 0 0 1 3.105-3.53 38.8 38.8 0 0 1 9.703-7.222c7.168-3.761 15.466-5.202 23.126-2.904.196.058.388.117.584.181"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M365.041 214.472a48.35 48.35 0 0 0-25.938 14.375 20.7 20.7 0 0 0-3.731 5.306 11.8 11.8 0 0 0-.961 6.162c.183 1.964.599 3.953.298 5.928a7.2 7.2 0 0 1-1.12 2.821 7.3 7.3 0 0 1-2.183 2.121c-2.132 1.416-4.649 1.986-7.13 2.459-2.755.525-5.625 1.027-7.924 2.737-.278.207-.586-.234-.307-.441 4-2.975 9.36-2.351 13.736-4.451 2.041-.98 3.799-2.577 4.304-4.848.443-1.985.015-4.036-.187-6.024a12.56 12.56 0 0 1 .714-6.059 19.1 19.1 0 0 1 3.511-5.429 46.8 46.8 0 0 1 11.3-9.245A49.3 49.3 0 0 1 365 213.936c.34-.067.379.469.041.536"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M341.187 226.34a7.17 7.17 0 0 1-1.64-4.689 7.18 7.18 0 0 1 1.806-4.629c.231-.258.646.086.415.345a6.64 6.64 0 0 0-1.681 4.308 6.64 6.64 0 0 0 1.544 4.359c.222.267-.224.571-.444.306M334.186 239.331a14.02 14.02 0 0 0 9.817-2.65c.28-.206.587.236.308.442a14.58 14.58 0 0 1-10.222 2.736c-.346-.038-.247-.566.097-.528M354.328 217.738a4.09 4.09 0 0 0 3.221 2.168c.346.034.247.562-.097.528a4.6 4.6 0 0 1-3.568-2.39.27.27 0 0 1-.04-.2.27.27 0 0 1 .108-.174.28.28 0 0 1 .202-.043c.07.013.133.053.174.111"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E616A",
    d: "M244.525 159.536a4.02 4.02 0 0 0 1.123-3.232 4.055 4.055 0 0 0-1.774-2.931l3.695-13.884-7.118 2.38-2.418 12.819a4.046 4.046 0 0 0 1.079 5.29 4.1 4.1 0 0 0 2.791.801 4.1 4.1 0 0 0 2.622-1.243M277.459 252.792h-4.958l-2.359-19.005 7.318.001z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "m278.723 257.568-15.987-.001v-.201c0-1.64.656-3.213 1.823-4.372a6.24 6.24 0 0 1 4.4-1.811h9.765z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E616A",
    d: "M254.002 252.792h-4.958l-2.359-19.005 7.318.001z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "m255.267 257.568-15.988-.001v-.201c0-1.64.656-3.213 1.823-4.372a6.24 6.24 0 0 1 4.4-1.811h9.765zM251.244 138.289l-1.903.523s-4.972 32.029-5.376 48.908c-.405 16.879 1.213 59.477 1.213 59.477h10.515l8.493-72.337 4.044 72.337h11.324s8.089-94.842 4.449-102.478-32.759-6.43-32.759-6.43"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E616A",
    d: "M266.413 81.773c5.248 0 9.502-4.227 9.502-9.442s-4.254-9.441-9.502-9.441c-5.247 0-9.501 4.227-9.501 9.441s4.254 9.442 9.501 9.442"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "m290.474 94.083-14.747-9.577-15.282.598-14.862 8.175 5.661 31.346-2.426 18.085s21.839-2.412 26.692 1.205a20.8 20.8 0 0 0 9.706 4.019l-.809-30.945z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "m248.414 92.878-1.528-.316-1.303.717s-3.64 4.823-3.64 9.244-4.449 47.019-4.449 47.019l8.089 3.617 6.47-33.356z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "M274.734 65.409s2.485-4.72-2.982-5.15c0 0-4.661-4.201-9.411-.768 0 0-2.592 0-4.009 2.914 0 0-2.038-.768-2.486 1.287 0 0-1.491 4.292 0 8.154s1.987 4.292 1.987 4.292-2.45-8.098 3.514-8.527c5.965-.43 12.639-4.133 13.136.587.498 4.721 1.246 5.884 1.246 5.884s4.721-6.742-.995-8.673"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M151.957 120.95H34.269V33.34h117.688z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M151.957 120.95H34.269V33.34h117.688zM35.483 34.546v85.198h115.261V34.546z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#286795",
    d: "M93.077 99.578c12.376 0 22.408-9.97 22.408-22.267 0-12.299-10.032-22.268-22.408-22.268s-22.41 9.97-22.41 22.268 10.034 22.267 22.41 22.267"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M102.382 75.44h-7.619v-7.57c0-.473-.189-.926-.525-1.26a1.8 1.8 0 0 0-2.535 0 1.78 1.78 0 0 0-.526 1.26v7.57h-7.619c-.475 0-.931.188-1.267.522a1.776 1.776 0 0 0 0 2.52c.336.334.792.522 1.267.522h7.62v7.57c0 .473.188.927.525 1.26a1.8 1.8 0 0 0 2.535 0c.336-.333.525-.787.525-1.26v-7.57h7.619c.476 0 .932-.188 1.268-.522a1.777 1.777 0 0 0 0-2.52 1.8 1.8 0 0 0-1.268-.521M43.977 32.976H0V0h43.977z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M43.977 32.976H0V0h43.977zM.809 32.172h42.36V.804H.808z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4E4E4",
    d: "M38.176 8.981H5.8v2.145h32.376zM38.176 15.415H5.8v2.145h32.376zM38.176 21.85H5.8v2.144h32.376z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M336.377 257.624H292.4v-32.976h43.977z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M336.377 257.624H292.4v-32.976h43.977zm-43.168-.804h42.359v-31.368h-42.359z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4E4E4",
    d: "M330.577 233.63h-32.376v2.145h32.376zM330.577 240.063h-32.376v2.145h32.376zM330.577 246.498h-32.376v2.145h32.376z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m309.67 198.455-32.848-29.056 22.064-24.63 32.848 29.055z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "m309.67 198.455-32.848-29.056 22.064-24.63 32.848 29.055zm-31.706-29.122 31.64 27.987 20.988-23.43-31.639-27.987z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4E4E4",
    d: "m297.209 155.309-1.435 1.602 24.183 21.391 1.436-1.602zM292.904 160.115l-1.435 1.602 24.183 21.391 1.435-1.602zM288.599 164.921l-1.435 1.602 24.183 21.392 1.435-1.602z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M68.877 52.265h-49.06V15.48h49.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M68.877 52.265h-49.06V15.48h49.06zm-48.158-.896h47.255V16.375H20.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#286795",
    d: "M62.405 25.498H26.288v2.393h36.117zM62.405 32.676H26.288v2.392h36.117zM62.405 39.854H26.288v2.392h36.117z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M196.194 148.569h-74.866V92.432h74.866z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M196.194 148.569h-74.866V92.432h74.866zm-73.489-1.368h72.112V93.8h-72.112z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#286795",
    d: "M186.319 107.721h-55.117v3.651h55.117zM186.319 118.674h-55.117v3.651h55.117zM186.319 129.628h-55.117v3.651h55.117z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CACACA",
    d: "M373.518 258H179.275a.48.48 0 0 1-.48-.479.48.48 0 0 1 .48-.478h194.243a.48.48 0 0 1 .482.478.48.48 0 0 1-.482.479"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E616A",
    d: "M285.446 159.233a4.02 4.02 0 0 1-.247-3.41 4 4 0 0 1 .97-1.462c.428-.411.94-.724 1.502-.917l.025-14.361 6.262 4.119-.983 13.006c.263.96.163 1.982-.282 2.874a4.08 4.08 0 0 1-2.13 1.962 4.12 4.12 0 0 1-2.905.061c-.943-.334-1.73-1-2.212-1.872"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "m286.025 95.69 2.798-2.68 2.055 1.475s2.022 2.411 3.64 9.645 0 47.019 0 47.019l-8.897-1.205 1.213-20.898-3.64-17.682z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h374v258H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDashboards);
export default __webpack_public_path__ + "static/media/noDashboards.92b7a20824e868e2c68051386ff5c8a5.svg";
export { ForwardRef as ReactComponent };